const shareBarPopup = Object.freeze({
  illustration: 'astronautTm',
  illustrationTransform: {
    x: '-49.03%',
    y: '-57.2%',
  },
  illustrationSizes: [
    { until: 's', value: 60, },
    { from: 's', until: 'l', value: 70, },
    { from: 'l', until: 'xl', value: 80, },
    { from: 'xl', value: 85, },
  ],
  textColor: 'white',
  textWidth: [
    { until: 'l', value: '35rem', },
    { from: 'l', value: '40rem', },
  ],
  fontStack: 'base',
  titleType: [
    { until: 's', value: 2, },
    { from: 's', until: 'l', value: 3, },
    { from: 'l', value: 4, },
  ],
  subtitleType: [
    { until: 's', value: 1, },
    { from: 's', until: 'l', value: 2, },
    { from: 'l', value: 3, },
  ],
  overlayBgColor: 'rgba(255,255,255,0.8)',
  closeBtnColor: [ 'neutral', '-1', ],
});

export default shareBarPopup;
